/* eslint-disable no-nested-ternary */
import React from 'react';
import { isEmpty } from 'lodash';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'slick-carousel/slick/slick-theme.css';
import { InnerPageSectionHeading } from './styles/SectionHeadline.styled';
import { SectionHeadingCenter } from './styles/SectionHeadingCenter.styled';
import { Container } from './styles/Container.styled';
import {
  SlideA,
  SuggestedSliderBlock,
  SliderImage,
  SliderCardCaption,
} from './styles/FullWidthSlider.styled';
import LoadMoreGenericBtn from './LoadMoreGenericBtn';

export default function Itineraries({ data, id, dir }) {
  const settings = {
    slidesToShow: false,
    swipeToSlide: false,
    infinite: false,
    dots: false,
    arrows: false,
    variableWidth: true,
    draggable: false,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          infinite: true,
          centerMode: true,
          variableWidth: false,
          centerPadding: '80px',
          draggable: true,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          infinite: true,
          centerMode: true,
          variableWidth: false,
          centerPadding: '30px',
          draggable: true,
        },
      },
    ],
  };
  const [loadMore, setLoadMore] = React.useState(false);
  const [hasMore, setHasMore] = React.useState(data.itineraryList.length > 6);
  const [itineraries, setItineraries] = React.useState(
    data.itineraryList.length <= 6 ? data.itineraryList : [...data.itineraryList.slice(0, 6)],
  );

  const handleLoadMore = () => setLoadMore(true);
  const loadmoreLabel = dir === 'rtl' ? 'تحميل المزيد' : 'Load More';
  React.useEffect(() => {
    if (loadMore && hasMore) {
      const currentLength = +itineraries.length;
      const isGrater = +currentLength < +data.itineraryList.length;
      const nextResults = isGrater
        ? data.itineraryList.slice(+currentLength, +currentLength + 8)
        : [];
      setItineraries([...itineraries, ...nextResults]);
      setLoadMore(false);
    }
  }, [loadMore, hasMore]);

  React.useEffect(() => {
    const isGrater = itineraries.length < data.itineraryList.length;
    setHasMore(isGrater);
  }, [itineraries]);

  return (
    <InnerPageSectionHeading id={id} className="itineraries_section">
      <Container>
        <SectionHeadingCenter>
          <h2 dir={dir} className="itinerariesh2">
            {data.title}
          </h2>
        </SectionHeadingCenter>
      </Container>
      <Container className="zeropadding_responsive">
        <SuggestedSliderBlock dir={dir} className="no-slider itineraries-slider">
          <Slider {...settings}>
            {itineraries.map(({ content }) => (
              <SlideA
                className="download-link-block"
                href={
                  isEmpty(content.file)
                    ? isEmpty(content.link)
                      ? ''
                      : content.link.url
                    : content.file.url
                }
                target="_blank"
                dir={dir}
              >
                <SliderImage>
                  {isEmpty(content.image) || (
                    <LazyLoadImage
                      src={content.image.url}
                      alt={content.title}
                      effect="blur"
                      placeholderSrc={
                        content.image ? `${content.image.url}?width=50&quality=50` : null
                      }
                    />
                  )}
                </SliderImage>
                <SliderCardCaption className="slider-caption" dir={dir}>
                  <h3 dir={dir}>{content.title}</h3>
                </SliderCardCaption>
              </SlideA>
            ))}
          </Slider>
        </SuggestedSliderBlock>
        {hasMore && (
          <LoadMoreGenericBtn
            color="blue"
            position="center"
            label={loadmoreLabel}
            onClick={handleLoadMore}
            dir={dir}
          />
        )}
      </Container>
    </InnerPageSectionHeading>
  );
}
